
import React, { useState } from "react";
import { Table, Button, Input, Space, } from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import Highlighter from "react-highlight-words";
import { SearchOutlined, ZoomInOutlined } from "@ant-design/icons";
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";

const { Search } = Input;

export default function SalesTable() {
  const reports = useReportsStore()
  const general = useGeneralStore();
  const { auth } = usePersistedStore();
  const [filterText, setFilterText] = useState("");
  const sales = reports.sales.data.DetailReport;
  const userInfo = auth.userInfo;
  const userInfoResources = auth.userInfo.Resources;
  const data = reports.sales.filtered;

  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [requestId, setRequestId] = useState();

  // const [checkboxValues, setCheckboxValues] = useState([]);
  // const [allCheckbox, setAllCheckbox] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  let userResources;
  if (userInfo) {
    userResources = userInfo.Resources
  }

  let searchInput;
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<ZoomInOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            ریست
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };


  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const handleClick = () => {
    reports.getRecalculateMultiple(selectedRowKeys);
    setSelectedRowKeys([]);


  };
  // const handleCheckboxChange = (event) => {
  //   const { value, checked } = event.target;

  //   if (checked) {
  //     setCheckboxValues((prevValues) => [...prevValues, value]);
  //   } else {
  //     setCheckboxValues((prevValues) =>
  //       prevValues.filter((item) => item !== value)
  //     );
  //   }

  // };
  // const allReqestId = sales && sales?.map(sale => (sale.RequestId))

  // const handleAllCheckboxChange = (event) => {
  //   const { value, checked } = event.target;
  //   if (checked) {

  //     setCheckboxValues(allReqestId);
  //   } else {
  //     setCheckboxValues([]);
  //   }

  // };


  const columns = [
    {
      title: " تنظیم مجدد کارمزد",
      dataIndex: "operation",
      key: "operation",
      width: 140,
      render: (_, record) =>
        userResources && userResources.includes('BusinessesManagment') &&
        sales.length >= 1 && (
          <Space size="middle">
            {/* <Checkbox
              value={record.RequestId}
              checked={checkboxValues.includes(record.RequestId)}
              onChange={handleCheckboxChange}
            /> */}
            <Button
              type="link"
              onClick={() => {
                reports.getRecalculateBusinessCommission(record.RequestId)
              }} size="small" >
              تنظیم مجدد کارمزد
            </Button>
          </Space>
        ),
    },

    {
      title: "جزئیات بیمه نامه",
      dataIndex: "operation",
      key: "operation",
      width: 85,
      render: (_, record) =>
        sales.length >= 1 && (
          <Space size="middle">
            <Button type='link' onClick={() => {
              reports.getInsuranceDetailsInfo(record.RequestId)
              setRequestId(record.RequestId);
              general.ToggleInsuranceDetailsModal();
            }
            }><ZoomInOutlined /></Button>
          </Space>
        ),
    },

    {
      title: "نام بیمه گزار",
      dataIndex: "PersonName",
      key: "PersonName",
      width: 110,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.PersonName ? (first = a.PersonName) : (first = "");
        b.PersonName ? (second = b.PersonName) : (second = "");
        return first.localeCompare(second);
      },
      render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    },
    {
      title: "نام کاربری",
      dataIndex: "UserName",
      key: "UserName",
      width: 100,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.UserName ? (first = a.UserName) : (first = "");
        b.UserName ? (second = b.UserName) : (second = "");
        return first.localeCompare(second);
      },
      render: text => text && strings.getFarsiNum(text),
    },
    {
      title: " کد ملی بیمه گزار ",
      dataIndex: "PolicyOwnerNationalCode",
      key: "PolicyOwnerNationalCode",
      width: 105,
      render: data => data && strings.getFarsiNum(data),
    },
    {
      title: "رشته",
      dataIndex: "BranchName",
      key: "BranchName",
      width: 100,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.BranchName ? first = a.BranchName : first = '';
        b.BranchName ? second = b.BranchName : second = '';
        return first.localeCompare(second)
      },
    },
    {
      title: "مبلغ حق بیمه",
      dataIndex: "Premium",
      key: "Premium",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مبلغ پرداختی",
      dataIndex: "Payment",
      key: "Payment",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مبلغ کد تخفیف",
      dataIndex: "VoucherAmount",
      key: "VoucherAmount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "تخفیف عدم ارسال",
      dataIndex: "NotSendDiscount",
      key: "NotSendDiscount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "تخفیف عدم بازدید",
      dataIndex: "NotVisitDiscount",
      key: "NotVisitDiscount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "سایر تخفیفات",
      dataIndex: "OtherDiscountsAmount",
      key: "OtherDiscountsAmount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "عودت",
      dataIndex: "ReturnToUser",
      key: "ReturnToUser",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "کارت به کارت",
      dataIndex: "CartToCartAmount",
      key: "CartToCartAmount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مدت بیمه نامه",
      dataIndex: "DurationTitle",
      key: "DurationTitle",
      width: 100,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.DurationTitle ? first = a.DurationTitle : first = '';
        b.DurationTitle ? second = b.DurationTitle : second = '';
        return first.localeCompare(second)
      },
    },
    {
      title: "شرکت بیمه",
      dataIndex: "CompanyName",
      key: "CompanyName",
      width: 100,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.CompanyName ? first = a.CompanyName : first = '';
        b.CompanyName ? second = b.CompanyName : second = '';
        return first.localeCompare(second)
      },
    },
    {
      title: "جریمه",
      dataIndex: "Penalty",
      key: "Penalty",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "روش پرداخت",
      dataIndex: "Installment",
      key: "Installment",
      width: 80,
      sorter: (a, b) => a.Installment - b.Installment,
      render: data => data ? 'اقساطی' : 'نقدی',
    },
    {
      title: "کارمزد کاربر",
      dataIndex: "CommissionAmount",
      key: "CommissionAmount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "کارمزد بیزینس",
      dataIndex: "BusinessWageAmount",
      key: "BusinessWageAmount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "درصد کارمزد بیزینس",
      dataIndex: "BusinessWagePercent",
      key: "BusinessWagePercent",
      ellipsis: true,
      width: 100,
      render: data => data && strings.getFarsiNum(data) + ' %',
    },
    {
      title: "مبلغ مالیات",
      dataIndex: "TaxAmount",
      key: "TaxAmount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "کد رهگیری",
      dataIndex: "TrackingCode",
      key: "TrackingCode",
      width: 105,
      sorter: (a, b) => a.TrackingCode.localeCompare(b.TrackingCode),
      ...getColumnSearchProps('TrackingCode', 'کد رهگیری'),
      render: text => text && text.toUpperCase().replace('BM-', '')
    },
    {
      title: "کد درخواست",
      dataIndex: "RequestId",
      key: "RequestId",
      ellipsis: true,
      width: 100,

      ...getColumnSearchProps('RequestId', 'کد درخواست'),
      render: data => data && strings.getFarsiNum(data),
    },
    {
      title: "تاریخ خرید",
      dataIndex: "BuyDate",
      key: "BuyDate",
      width: 110,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.BuyDate ? first = a.BuyDate : first = '';
        b.BuyDate ? second = b.BuyDate : second = '';
        return first.localeCompare(second)
      },
      render: data => strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
    },
    {
      title: "تاریخ صدور",
      dataIndex: "IssuanceDate",
      key: "IssuanceDate",
      width: 110,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.IssuanceDate ? first = a.IssuanceDate : first = '';
        b.IssuanceDate ? second = b.IssuanceDate : second = '';
        return first.localeCompare(second)
      },
      render: data => data && strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD')),
    },
    {
      title: "نام بازاریاب",
      dataIndex: "PromoterFullName",
      key: "PromoterFullName",
      width: 100,
      // sorter: (a, b) => {
      //   let first = "";
      //   let second = "";
      //   a.PromoterFullName ? (first = a.PromoterFullName) : (first = "");
      //   b.PromoterFullName ? (second = b.PromoterFullName) : (second = "");
      //   return first.localeCompare(second);
      // },
      render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    }


  ];

  const handleSearchFilter = (e) => {
    setFilterText(e.target.value);
    sales && reports.filterSales({ value: e.target.value });
  }
  function handlePaste(event) {
    let paste = (event.clipboardData || window.clipboardData).getData("text");
    paste = paste.split("|").join(",");
    setFilterText(paste)
  }
  return (
    <div className="sales-table">
      <div dir="rtl">
        <Search
          className="table-search"
          placeholder="جستجو بر اساس نام بیمه گزار ، نام کاربری ، رشته، مدت بیمه نامه، شرکت بیمه"
          onChange={handleSearchFilter}
          onPaste={handlePaste} />
      </div>
      {userResources && userResources.includes('BusinessesManagment') &&
        <div>

          <button type="primary" className="btn btn-primary waves-effect waves-light"
            onClick={handleClick}
            htmltype="submit"
            disabled={!selectedRowKeys.length > 0}

          >
            تنظیم مجدد کارمزد
          </button>
        </div>}
      <Table
        className="custom-table row-selection "
        size="small"
        bordered
        columns={userInfoResources &&
          (userInfoResources.includes("BusinessSaleReport") ||
            userInfoResources.includes("BusinessSupportReport")) ?
          columns : (columns.filter(col => col.dataIndex !== 'operation'))}
        rowKey="RequestId"
        dataSource={filterText ? data : sales}

        rowSelection={rowSelection}
        scroll={{ x: 'max-content' }}
      />
      <InsuranceDetails requestId={requestId} />
    </div>
  );
}